import { Button, Col, Form, Input, Row, Select, Tooltip } from 'antd';
import _ from 'lodash';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import {
  authFeatureConstants, DEFAULT_PAGE_SIZE, GUTTOR_SPACE, INVENTORY_MESSAGE_CONSTANTS,
  INVENTROY_CONSTANTS, PACKAGE_TYPE, REQUEST_PAYLOAD_FOR_ROOM,
} from '../../../../shared/constants/commonConstants';
import { FETCH_INVENTORY_DASHBOARD, INVENTORY_FETCH_IP_PACKAGE } from '../../../../shared/constants/urlEndPoints';
import { FetchInPatientPackageRequest, FetchInPatientPackageResponse } from '../../../../shared/models/inPatient.model';
import { LookUpDetail } from '../../../../shared/models/lookUp.model';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { fetchHospitalProfile } from '../../../../store/actions/hospitalAction';
import { fetchIPDepartmentMaster } from '../../../../store/actions/inventoryAction';
import { dashBoardRequest } from '../../../../store/actions/leftSideBarAction';
import { canActivate, error, extractSecondLevelBaseUrl, GetFirstElement } from '../../../../utils/utility';
import NoDataFound from '../../shared/NoDataFound';
import IPPackagesList from './IPPackagesList';
import { IPPackageListColumns } from '../../../../shared/constants/commonConstants';
import LoadTable from '../../shared/LoadTable';

const IPPackages = ({ match }: any): ReactElement => {
  const pageNumber: any = new URLSearchParams(useLocation().search).get('page');
  const dispatch = useDispatch();
  const history = useHistory();
  const storedHospitalProfile: any = useSelector(
    ({ hospital: { hospitalProfile } }: any): any => hospitalProfile,
  );
  const departmentMasterList = useSelector(
    ({ inventory: { inPatientdepartmentMaster } }: any): any => inPatientdepartmentMaster,
  );
  const [hospIPPackages, setHospIPPackages] = useState(null as any);
  const [currentPage, setCurrentPage] = useState(pageNumber ? pageNumber : 1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [inputSearchText, setInputSearchText] = useState('');
  const [noRecordsOnFilter, setNoRecordsOnFilter] = useState(false);
  const [filterOption, setFilterOption] = useState([] as any);
  const dashboardPayload: any = {
    title: INVENTORY_MESSAGE_CONSTANTS.title.ip,
    url: `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${FETCH_INVENTORY_DASHBOARD}`, type: PACKAGE_TYPE.INPATIENT,
  };

  useEffect((): void => {
    if (!storedHospitalProfile) {
      dispatch(fetchHospitalProfile(REQUEST_PAYLOAD_FOR_ROOM));
    }
    if (!departmentMasterList) {
      dispatch(fetchIPDepartmentMaster());
    }
    loadDefault();
    if (pageNumber) {
      removeQueryParam();
    }
  }, []);

  const fetchPackages = async (
    payload: any, isThrowError: boolean = false, isRemovePackageOnError: boolean = false, isFlag?: boolean,
  ): Promise<any> => {
    dashboardPayload.filter = {
      departmentIds: payload?.departmentIds,
      name: payload?.name,
      statusName: payload?.statusType ? payload?.statusType : 'NA',
    };
    if (!isFlag) {
      dispatch(dashBoardRequest(dashboardPayload));
    }
    const url = `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${INVENTORY_FETCH_IP_PACKAGE}`;
    const response: any = await SendRequest.instance.post<FetchInPatientPackageRequest,
      FetchInPatientPackageResponse>(url, payload);
    if (response && response.isSuccess && response.packages && response.packages.length > 0) {
      setHospIPPackages(response.packages);
      setTotalRecords(response.totalRecords);
    } else {
      if (isThrowError) {
        error(INVENTORY_MESSAGE_CONSTANTS.tryAgain);
      }
      if (isRemovePackageOnError) {
        setHospIPPackages(null);
      }
      setNoRecordsOnFilter(true);
    }
  };
  const onPaginationData = (page: number, pagesize: number): any => {
    setCurrentPage(page);
    const payload: FetchInPatientPackageRequest = {
      packageByProfileId: true,
      fetchInActiveRecord: true,
      pageNumber: page,
      pageSize: pagesize,
      profileIds: [ApplicationDetail.instance.getProfileId()],
      packageType: INVENTROY_CONSTANTS.packageType_InPatient,
    };
    fetchPackages(payload);
  };

  const removeQueryParam = (): void => {
    window.history.pushState('', '', window.location.pathname);
  };

  const loadDefault = (): void => {
    const payload: FetchInPatientPackageRequest = {
      packageByProfileId: true,
      fetchInActiveRecord: true,
      pageNumber: currentPage,
      pageSize: DEFAULT_PAGE_SIZE,
      profileIds: [ApplicationDetail.instance.getProfileId()],
      packageType: INVENTROY_CONSTANTS.packageType_InPatient,
      packageByDepartmentId: filterOption && filterOption.length > 0,
      departmentIds: filterOption?.map((x: LookUpDetail): any => x.id),
    };
    fetchPackages(payload, false, false, true);
  };
  const newIPPackage = (): void => {
    history.push(extractSecondLevelBaseUrl(match?.path) + INVENTROY_CONSTANTS.newIpPackageRoute);
  };

  useEffect((): void => {
    if (storedHospitalProfile && storedHospitalProfile.rooms) {
      isRoomsConfigured();
    }
  }, [storedHospitalProfile]);

  const isRoomsConfigured = (): any => {
    const profile: any = GetFirstElement(storedHospitalProfile);
    if (profile && (!profile.rooms || profile.rooms.length === 0)) {
      error(INVENTORY_MESSAGE_CONSTANTS.roomsNotConfigured);
    }
  };

  const onSearchByName = (inputText: string): void => {
    if (inputText.length >= 3) {
      setInputSearchText(inputText);
      const payload: FetchInPatientPackageRequest = {
        packageByProfileId: true,
        packageByDepartmentId: filterOption && filterOption.length > 0,
        fetchInActiveRecord: true,
        pageNumber: 1,
        pageSize: DEFAULT_PAGE_SIZE,
        profileIds: [ApplicationDetail.instance.getProfileId()],
        departmentIds: filterOption?.map((x: LookUpDetail): any => x.id),
        packageByName: true,
        name: inputText,
        packageType: INVENTROY_CONSTANTS.packageType_InPatient,
      };
      fetchPackages(payload, false, true);
      setCurrentPage(1);
    }
    if (inputText.length === 0) {
      loadDefault();
      setInputSearchText('');
    }
  };
  const onFilterByDepartment = async (selectedDepartments: string[]): Promise<any> => {
    const dep = departmentMasterList.filter((vv: LookUpDetail): boolean => {
      return selectedDepartments.findIndex((c: string): boolean => c === vv.value) > -1;
    });
    const payload: FetchInPatientPackageRequest = {
      packageByProfileId: true,
      fetchInActiveRecord: true,
      pageNumber: currentPage,
      pageSize: DEFAULT_PAGE_SIZE,
      profileIds: [ApplicationDetail.instance.getProfileId()],
      packageByDepartmentId: dep && dep.length > 0,
      departmentIds: dep?.map((x: LookUpDetail): any => x.id),
      packageType: INVENTROY_CONSTANTS.packageType_InPatient,
    };
    fetchPackages(payload, false, true);
    setFilterOption(dep);
  };
  return (
    <div>
      <PageHeader
        pageTitle={INVENTORY_MESSAGE_CONSTANTS.title.ip}
        customeClass={'inv-page-header-align'}
        rightComponent={
          (): ReactElement =>
            <Row gutter={GUTTOR_SPACE}>
              <Col md={4} />
              <Col md={8}>
                <Select
                  mode="multiple"
                  className="w-100 scrollable-select mouse-pointer"
                  placeholder="Department"
                  optionLabelProp="label"
                  allowClear={true}
                  options={departmentMasterList?.map((x: any): any => {
                    return {
                      id: x.id,
                      name: x.value,
                      value: x.value,
                      key: x.id,
                    };
                  })}
                  onChange={onFilterByDepartment}
                  value={filterOption?.map((x: LookUpDetail): any => x.value)}
                />
              </Col>
              <Col md={8} style={{ textAlign: 'left' }}>
                <Form.Item>
                  <Input placeholder="Search" allowClear={true} ref={(input: any): any => input && input.focus()}
                    defaultValue={inputSearchText} onChange={(e: any): void => onSearchByName(e.target.value)}
                  />
                </Form.Item>
              </Col>
              {
                canActivate(authFeatureConstants.EDIT_IP_PACKAGES) &&
                <Col md={4}>
                  <div className="text-right">
                    <Tooltip placement={'left'} title={(storedHospitalProfile && GetFirstElement(storedHospitalProfile)?.rooms) ? '' : 'Rooms are not configured, please configure rooms to proceed.'}>
                      <Button
                        disabled={(storedHospitalProfile && GetFirstElement(storedHospitalProfile)?.rooms) ? false : true}
                        type="primary" onClick={(): void => newIPPackage()} > + Add Package</Button>
                    </Tooltip>
                  </div>
                </Col>
              }
            </Row>}
      />
      {hospIPPackages && storedHospitalProfile ?
        <div className="ant-tabs-content-holder tab-custom-container">
          <IPPackagesList packageItems={hospIPPackages} rooms={GetFirstElement(storedHospitalProfile)?.rooms} match={match}
            currentPageNo={currentPage} totalRecords={totalRecords} onPaginationEvent={onPaginationData} />
        </div>
        : noRecordsOnFilter ? <NoDataFound /> : <LoadTable columns={IPPackageListColumns} />}
    </div>
  );
};
export default IPPackages;
